
// // import React, { useEffect, useState, useMemo } from "react";
// // import { useLoader } from '../../../../context/LoaderProvider.jsx';
// // import {
// //     getEngineeringEnquiriesAPI,
// // } from "../../../Servicefile/clientManagementService.jsx";
// // const Engineeringenquery = () => {
// //     const [data, setData] = useState([]);
// //     const [screenWidth, setScreenWidth] = useState(window.innerWidth);
// //     const { showLoader, hideLoader } = useLoader();

// //     // Filter states
// //     const [searchType, setSearchType] = useState("vendorId");
// //     const [searchQuery, setSearchQuery] = useState("");
// //     const [statusFilter, setStatusFilter] = useState("");
// //     const [cityFilter, setCityFilter] = useState("");
// //     const [filteredData, setFilteredData] = useState([]);

// //     useEffect(() => {
// //         const handleResize = () => setScreenWidth(window.innerWidth);
// //         window.addEventListener("resize", handleResize);
// //         return () => window.removeEventListener("resize", handleResize);
// //     }, []);


// //     useEffect(() => {

// //         const controller =
// //             new AbortController();

// //         const fetchUsers =
// //             async () => {

// //                 showLoader();

// //                 // Optional delay
// //                 await new Promise(
// //                     (resolve) =>
// //                         setTimeout(
// //                             resolve,
// //                             50
// //                         )
// //                 );

// //                 try {

// //                     const data =
// //                         await getEngineeringEnquiriesAPI(
// //                             controller.signal
// //                         );

// //                     setData(data);

// //                     setFilteredData(
// //                         data
// //                     );

// //                 } catch (err) {

// //                     if (
// //                         err.name !==
// //                         "AbortError"
// //                     ) {

// //                         console.error(
// //                             "Error fetching users:",
// //                             err
// //                         );
// //                     }

// //                 } finally {

// //                     hideLoader();
// //                 }
// //             };

// //         fetchUsers();

// //         return () =>
// //             controller.abort();

// //     }, []);

// //     // Apply filters
// //     useEffect(() => {
// //         let result = data;

// //         // Apply status filter
// //         if (statusFilter) {
// //             result = result.filter(item => item.status === statusFilter);
// //         }

// //         // Apply city filter
// //         if (cityFilter) {
// //             result = result.filter(item => item.city === cityFilter);
// //         }

// //         // Apply search query
// //         if (searchQuery.trim()) {
// //             const query = searchQuery.toLowerCase().trim();
// //             result = result.filter(item => {
// //                 // Get the field value based on searchType
// //                 let fieldValue;

// //                 // Handle different field names in the data
// //                 if (searchType === "vendorId") {
// //                     fieldValue = item.vendorId || item.id;
// //                 } else if (searchType === "phoneNumber") {
// //                     fieldValue = item.mobileNumber || item.phone;
// //                 } else if (searchType === "email") {
// //                     fieldValue = item.email;
// //                 } else if (searchType === "name") {
// //                     fieldValue = item.name;
// //                 } else if (searchType === "city") {
// //                     fieldValue = item.city;
// //                 } else {
// //                     fieldValue = item[searchType];
// //                 }

// //                 if (!fieldValue) return false;

// //                 // For phone number search, clean non-digits
// //                 if (searchType === "phoneNumber") {
// //                     const cleanPartnerMobile = fieldValue.toString().replace(/\D/g, '');
// //                     const cleanQuery = query.replace(/\D/g, '');
// //                     return fieldValue.toString().toLowerCase().includes(query) ||
// //                         cleanPartnerMobile.includes(cleanQuery);
// //                 }

// //                 // For other fields
// //                 return fieldValue.toString().toLowerCase().includes(query);
// //             });
// //         }

// //         setFilteredData(result);
// //     }, [data, statusFilter, cityFilter, searchType, searchQuery]);

// //     // Get unique values for filter dropdowns
// //     const uniqueCities = useMemo(() => {
// //         const cities = data.map(item => item.city).filter(Boolean);
// //         return [...new Set(cities)].sort();
// //     }, [data]);

// //     const uniqueStatuses = useMemo(() => {
// //         const statuses = data.map(item => item.status).filter(Boolean);
// //         return [...new Set(statuses)].sort();
// //     }, [data]);

// //     // Clear all filters
// //     const clearAllFilters = () => {
// //         setSearchQuery("");
// //         setStatusFilter("");
// //         setCityFilter("");
// //         setSearchType("vendorId");
// //     };

// //     // Get placeholder text based on search type
// //     const getPlaceholderText = () => {
// //         switch (searchType) {
// //             case "vendorId": return "Search Vendor ID";
// //             case "name": return "Search Name";
// //             case "email": return "Search Email";
// //             case "phoneNumber": return "Search Mobile Number";
// //             case "city": return "Search City";
// //             default: return "Search...";
// //         }
// //     };

// //     // Search options
// //     const searchOptions = [
// //         { value: "vendorId", label: "Vendor ID" },
// //         { value: "name", label: "Name" },
// //         { value: "email", label: "Email" },
// //         { value: "phoneNumber", label: "Mobile Number" },
// //         { value: "city", label: "City" }
// //     ];

// //     return (
// //         <div className="container-fluid">
// //             <div className="row">
// //                 <div className="col-lg-12" style={{ marginTop: "0px" }}>
// //                     <div
// //                         className="user-management-page"
// //                         style={{
// //                             overflowY: "auto",
// //                             height: "66vh",
// //                             scrollbarWidth: "thin",
// //                             marginTop: "15px",
// //                             position: "relative"
// //                         }}
// //                     >
// //                         <div className="user-management-container" style={{ marginLeft: "0px" }}>

// //                             {/* Filter Controls - Same as Logisticsclients */}
// //                             <div className="row g-2 mb-1 align-items-center me-0">
// //                                 {/* Search Type Dropdown and Search Input - Side by Side */}
// //                                 <div className="col-md-auto col-12">
// //                                     <div className="d-flex align-items-center" style={{ gap: '10px' }}>
// //                                         {/* Search Type Dropdown */}
// //                                         <div style={{ minWidth: '150px' }}>
// //                                             <select
// //                                                 className="form-select"
// //                                                 value={searchType}
// //                                                 onChange={(e) => setSearchType(e.target.value)}
// //                                                 style={{ height: "40px" }}
// //                                             >
// //                                                 {searchOptions.map(option => (
// //                                                     <option key={option.value} value={option.value}>
// //                                                         {option.label}
// //                                                     </option>
// //                                                 ))}
// //                                             </select>
// //                                         </div>

// //                                         {/* Search Input */}
// //                                         <div style={{ minWidth: '200px' }}>
// //                                             <input
// //                                                 type="text"
// //                                                 className="form-control"
// //                                                 placeholder={getPlaceholderText()}
// //                                                 value={searchQuery}
// //                                                 onChange={(e) => setSearchQuery(e.target.value)}
// //                                                 style={{ height: "40px" }}
// //                                             />
// //                                         </div>
// //                                     </div>
// //                                 </div>

// //                                 {/* Clear Filters Button */}
// //                                 <div className="col-md-auto col-12">
// //                                     <button
// //                                         className="btn"
// //                                         onClick={clearAllFilters}
// //                                         style={{
// //                                             backgroundColor: '#6c757d',
// //                                             color: '#fff',
// //                                             height: "40px",
// //                                             padding: "0 15px"
// //                                         }}
// //                                     >
// //                                         Clear Filters
// //                                     </button>
// //                                 </div>

// //                                 {/* Refresh Data Button */}
// //                                 <div className="col-md col-12">
// //                                     <div className="d-flex justify-content-start justify-content-md-end">
// //                                         <button
// //                                             className="btn"
// //                                             onClick={() => window.location.reload()}
// //                                             style={{
// //                                                 backgroundColor: 'rgb(230 109 51)',
// //                                                 color: '#fff',
// //                                                 height: "40px",
// //                                                 padding: "0 20px"
// //                                             }}
// //                                         >
// //                                             Refresh Data
// //                                         </button>
// //                                     </div>
// //                                 </div>
// //                             </div>

// //                             <div className="user-table-wrapper" style={{ position: "relative", marginTop: "10px" }}>
// //                                 <table style={{ width: "100%", fontSize: "0.95rem", borderCollapse: "collapse" }}>
// //                                     <thead style={{
// //                                         position: "sticky",
// //                                         top: 0,
// //                                         zIndex: 10,
// //                                         backgroundColor: "rgb(230 109 51)"
// //                                     }}>
// //                                         <tr>
// //                                             <th style={tableHeaderStyle}>S.NO</th>
// //                                             <th style={tableHeaderStyle}>Name</th>
// //                                             <th style={tableHeaderStyle}>Email</th>
// //                                             <th style={tableHeaderStyle}>Phone</th>
// //                                             <th style={tableHeaderStyle}>City</th>
// //                                             {/* <th style={tableHeaderStyle}>Vendor ID</th> */}
// //                                         </tr>
// //                                     </thead>
// //                                     <tbody>
// //                                         {filteredData.length > 0 ? (
// //                                             filteredData.map((user, index) => (
// //                                                 <tr key={user.vendorId || index} style={{ backgroundColor: index % 2 === 0 ? "#f9f9f9" : "#fff" }}>
// //                                                     <td style={tableCellStyle}>{user.sno}</td>
// //                                                     <td style={tableCellStyle}>{user.name}</td>
// //                                                     <td style={tableCellStyle}>{user.email}</td>
// //                                                     <td style={tableCellStyle}>{user.mobileNumber}</td>
// //                                                     <td style={tableCellStyle}>{user.city}</td>
// //                                                     {/* <td style={tableCellStyle}>{user.vendorId}</td> */}
// //                                                 </tr>
// //                                             ))
// //                                         ) : (
// //                                             <tr>
// //                                                 <td colSpan="5" style={noDataStyle}>
// //                                                     {data.length === 0
// //                                                         ? "Loading data or no customers found."
// //                                                         : (searchQuery.trim() || statusFilter || cityFilter)
// //                                                             ? "No data found with the specified filters."
// //                                                             : "No data available."}
// //                                                 </td>
// //                                             </tr>
// //                                         )}
// //                                     </tbody>
// //                                 </table>
// //                             </div>
// //                         </div>
// //                     </div>
// //                 </div>
// //             </div>
// //         </div>
// //     );
// // };

// // // Styles
// // const tableHeaderStyle = {
// //     border: "1px solid #ddd",
// //     textAlign: "center",
// //     fontWeight: "bold",
// //     backgroundColor: "rgb(230 109 51)",
// //     color: "white",
// //     padding: "6px",
// //     position: "sticky",
// //     top: 0,
// //     zIndex: 10
// // };

// // const tableCellStyle = {
// //     border: "1px solid #ddd",
// //     textAlign: "center",
// //     padding: "6px",
// // };

// // const noDataStyle = {
// //     fontStyle: "italic",
// //     textAlign: "center",
// //     padding: "10px",
// //     color: "#888",
// // };

// // export default Engineeringenquery;







// import React, { useEffect, useState, useMemo } from "react";
// import { useLoader } from '../../../../context/LoaderProvider.jsx';
// import {
//     getEngineeringEnquiriesAPI,
// } from "../../../Servicefile/clientManagementService.jsx";

// // ============================================
// // PREMIUM ICONS COMPONENT
// // ============================================
// const Icons = {
//     Search: () => (
//         <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
//             <circle cx="11" cy="11" r="8"/><path d="M21 21l-4.35-4.35"/>
//         </svg>
//     ),
//     Refresh: () => (
//         <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
//             <path d="M23 4v6h-6M1 20v-6h6"/>
//             <path d="M3.51 9a9 9 0 0 1 14.85-3.36L23 10M1 14l4.64 4.36A9 9 0 0 0 20.49 15"/>
//         </svg>
//     ),
//     Clear: () => (
//         <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
//             <line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/>
//         </svg>
//     ),
//     Filter: () => (
//         <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
//             <polygon points="22 3 2 3 10 13 10 21 14 18 14 13 22 3"/>
//         </svg>
//     ),
//     User: () => (
//         <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
//             <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"/>
//             <circle cx="12" cy="7" r="4"/>
//         </svg>
//     ),
//     Email: () => (
//         <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
//             <rect x="2" y="4" width="20" height="16" rx="2"/>
//             <path d="M22 7l-8.97 5.7a1.94 1.94 0 0 1-2.06 0L2 7"/>
//         </svg>
//     ),
//     Phone: () => (
//         <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
//             <path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72c.127.96.362 1.903.7 2.81a2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45c.907.339 1.85.574 2.81.7A2 2 0 0 1 22 16.92z"/>
//         </svg>
//     ),
//     NoData: () => (
//         <svg width="48" height="48" viewBox="0 0 24 24" fill="none" stroke="#6c757d" strokeWidth="1.5">
//             <rect x="2" y="3" width="20" height="18" rx="2"/>
//             <line x1="8" y1="21" x2="16" y2="21"/>
//             <line x1="12" y1="17" x2="12" y2="21"/>
//             <path d="M8 7h8M8 11h6M8 15h4"/>
//         </svg>
//     ),
//     Engineering: () => (
//         <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="rgb(230 109 51)" strokeWidth="2">
//             <path d="M12 2L2 7l10 5 10-5-10-5z"/>
//             <path d="M2 17l10 5 10-5"/>
//             <path d="M2 12l10 5 10-5"/>
//         </svg>
//     ),
//     Calendar: () => (
//         <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
//             <rect x="3" y="4" width="18" height="18" rx="2" ry="2"/>
//             <line x1="16" y1="2" x2="16" y2="6"/>
//             <line x1="8" y1="2" x2="8" y2="6"/>
//             <line x1="3" y1="10" x2="21" y2="10"/>
//         </svg>
//     )
// };

// // ============================================
// // PREMIUM STYLES
// // ============================================
// const styles = {
//     container: {
//         padding: '1px 5px',
    
//         height: 'calc(100vh - 200px)',
//         display: 'flex',
//         flexDirection: 'column'
//     },
//     header: {
//         display: 'flex',
//         justifyContent: 'space-between',
//         alignItems: 'center',
//         padding: '0 0 16px 0',
//         borderBottom: '2px solid #e9ecef',
//         flexWrap: 'wrap',
//         gap: '12px'
//     },
//     title: {
//         fontSize: '20px',
//         fontWeight: '600',
//         color: '#2d3748',
//         letterSpacing: '-0.3px',
//         display: 'flex',
//         alignItems: 'center',
//         gap: '10px'
//     },
//     titleBadge: {
//         background: 'rgb(230 109 51)',
//         color: 'white',
//         fontSize: '12px',
//         fontWeight: '500',
//         padding: '2px 12px',
//         borderRadius: '12px',
//         letterSpacing: '0.3px'
//     },
//     filtersContainer: {
//         display: 'flex',
//         flexWrap: 'wrap',
//         alignItems: 'center',
//         gap: '10px',
//         padding: '12px 0',
//         borderBottom: '1px solid #edf2f7',
//         marginBottom: '12px'
//     },
//     searchGroup: {
//         display: 'flex',
//         alignItems: 'center',
//         gap: '8px',
//         flex: '1 1 auto',
//         minWidth: '280px'
//     },
//     select: {
//         padding: '8px 12px',
//         border: '1px solid #e2e8f0',
//         borderRadius: '8px',
//         background: 'white',
//         fontSize: '13px',
//         fontWeight: '500',
//         color: '#2d3748',
//         outline: 'none',
//         transition: 'all 0.2s ease',
//         height: '38px',
//         minWidth: '130px',
//         cursor: 'pointer'
//     },
//     input: {
//         flex: '1',
//         padding: '8px 14px',
//         border: '1px solid #e2e8f0',
//         borderRadius: '8px',
//         fontSize: '13px',
//         color: '#2d3748',
//         outline: 'none',
//         transition: 'all 0.2s ease',
//         height: '38px',
//         background: 'white'
//     },
//     button: {
//         padding: '8px 16px',
//         borderRadius: '8px',
//         border: 'none',
//         fontWeight: '500',
//         fontSize: '13px',
//         display: 'flex',
//         alignItems: 'center',
//         gap: '6px',
//         cursor: 'pointer',
//         transition: 'all 0.2s ease',
//         height: '38px',
//         whiteSpace: 'nowrap'
//     },
//     buttonPrimary: {
//         background: 'rgb(230 109 51)',
//         color: 'white'
//     },
//     buttonSecondary: {
//         background: '#e2e8f0',
//         color: '#4a5568'
//     },
//     buttonOutline: {
//         background: 'transparent',
//         border: '1px solid #e2e8f0',
//         color: '#4a5568'
//     },
//     tableWrapper: {
//         flex: '1',
//         overflow: 'auto',
//         borderRadius: '10px',
//         border: '1px solid #edf2f7',
//         background: 'white',
//         position: 'relative'
//     },
//     table: {
//         width: '100%',
//         fontSize: '13px',
//         borderCollapse: 'collapse',
//         minWidth: '600px'
//     },
//     thead: {
//         position: 'sticky',
//         top: 0,
//         zIndex: 20
//     },
//     th: {
//         padding: '12px 14px',
//         textAlign: 'left',
//         fontWeight: '600',
//         fontSize: '12px',
//         textTransform: 'uppercase',
//         letterSpacing: '0.5px',
//         color: 'white',
//         background: 'rgb(230 109 51)',
//         borderBottom: '2px solid #d45a1a',
//         whiteSpace: 'nowrap'
//     },
//     td: {
//         padding: '10px 14px',
//         borderBottom: '1px solid #f1f5f9',
//         color: '#2d3748',
//         fontSize: '13px',
//         textAlign: 'center'
//     },
//     statusBadge: {
//         display: 'inline-flex',
//         alignItems: 'center',
//         gap: '4px',
//         padding: '3px 12px',
//         borderRadius: '20px',
//         fontSize: '11px',
//         fontWeight: '500',
//         letterSpacing: '0.3px'
//     },
//     statusActive: {
//         background: '#c6f6d5',
//         color: '#276749'
//     },
//     statusInactive: {
//         background: '#fed7d7',
//         color: '#9b2c2c'
//     },
//     statusPending: {
//         background: '#fefcbf',
//         color: '#975a16'
//     },
//     statusNew: {
//         background: '#bee3f8',
//         color: '#2a4365'
//     },
//     emptyState: {
//         display: 'flex',
//         flexDirection: 'column',
//         alignItems: 'center',
//         justifyContent: 'center',
//         padding: '60px 20px',
//         color: '#a0aec0'
//     },
//     emptyStateText: {
//         marginTop: '16px',
//         fontSize: '16px',
//         fontWeight: '500',
//         color: '#4a5568'
//     },
//     emptyStateSubtext: {
//         fontSize: '13px',
//         color: '#a0aec0',
//         marginTop: '4px'
//     },
//     statsBar: {
//         display: 'flex',
//         alignItems: 'center',
//         gap: '16px',
//         padding: '8px 0 0 0',
//         fontSize: '12px',
//         color: '#718096'
//     },
//     statItem: {
//         display: 'flex',
//         alignItems: 'center',
//         gap: '4px'
//     },
//     statNumber: {
//         fontWeight: '600',
//         color: '#2d3748'
//     },
//     contactInfo: {
//         display: 'flex',
//         alignItems: 'center',
//         gap: '4px',
//         justifyContent: 'center'
//     },
//     emailLink: {
//         color: '#4a5568',
//         textDecoration: 'none',
//         transition: 'color 0.2s ease'
//     }
// };

// const Engineeringenquery = () => {
//     const [data, setData] = useState([]);
//     const [screenWidth, setScreenWidth] = useState(window.innerWidth);
//     const { showLoader, hideLoader } = useLoader();

//     // Filter states
//     const [searchType, setSearchType] = useState("vendorId");
//     const [searchQuery, setSearchQuery] = useState("");
//     const [statusFilter, setStatusFilter] = useState("");
//     const [cityFilter, setCityFilter] = useState("");
//     const [filteredData, setFilteredData] = useState([]);

//     useEffect(() => {
//         const handleResize = () => setScreenWidth(window.innerWidth);
//         window.addEventListener("resize", handleResize);
//         return () => window.removeEventListener("resize", handleResize);
//     }, []);

//     useEffect(() => {
//         const controller = new AbortController();

//         const fetchUsers = async () => {
//             showLoader();
//             await new Promise((resolve) => setTimeout(resolve, 50));

//             try {
//                 const data = await getEngineeringEnquiriesAPI(controller.signal);
//                 setData(data);
//                 setFilteredData(data);
//             } catch (err) {
//                 if (err.name !== "AbortError") {
//                     console.error("Error fetching users:", err);
//                 }
//             } finally {
//                 hideLoader();
//             }
//         };

//         fetchUsers();
//         return () => controller.abort();
//     }, []);

//     // Apply filters
//     useEffect(() => {
//         let result = data;

//         if (statusFilter) {
//             result = result.filter(item => item.status === statusFilter);
//         }

//         if (cityFilter) {
//             result = result.filter(item => item.city === cityFilter);
//         }

//         if (searchQuery.trim()) {
//             const query = searchQuery.toLowerCase().trim();
//             result = result.filter(item => {
//                 let fieldValue;

//                 if (searchType === "vendorId") {
//                     fieldValue = item.vendorId || item.id;
//                 } else if (searchType === "phoneNumber") {
//                     fieldValue = item.mobileNumber || item.phone;
//                 } else if (searchType === "email") {
//                     fieldValue = item.email;
//                 } else if (searchType === "name") {
//                     fieldValue = item.name;
//                 } else if (searchType === "city") {
//                     fieldValue = item.city;
//                 } else {
//                     fieldValue = item[searchType];
//                 }

//                 if (!fieldValue) return false;

//                 if (searchType === "phoneNumber") {
//                     const cleanPartnerMobile = fieldValue.toString().replace(/\D/g, '');
//                     const cleanQuery = query.replace(/\D/g, '');
//                     return fieldValue.toString().toLowerCase().includes(query) ||
//                         cleanPartnerMobile.includes(cleanQuery);
//                 }

//                 return fieldValue.toString().toLowerCase().includes(query);
//             });
//         }

//         setFilteredData(result);
//     }, [data, statusFilter, cityFilter, searchType, searchQuery]);

//     const uniqueCities = useMemo(() => {
//         const cities = data.map(item => item.city).filter(Boolean);
//         return [...new Set(cities)].sort();
//     }, [data]);

//     const uniqueStatuses = useMemo(() => {
//         const statuses = data.map(item => item.status).filter(Boolean);
//         return [...new Set(statuses)].sort();
//     }, [data]);

//     const clearAllFilters = () => {
//         setSearchQuery("");
//         setStatusFilter("");
//         setCityFilter("");
//         setSearchType("vendorId");
//     };

//     const getPlaceholderText = () => {
//         switch (searchType) {
//             case "vendorId": return "Search by Vendor ID...";
//             case "name": return "Search by Name...";
//             case "email": return "Search by Email...";
//             case "phoneNumber": return "Search by Mobile...";
//             case "city": return "Search by City...";
//             default: return "Search...";
//         }
//     };

//     const getStatusStyle = (status) => {
//         if (!status) return styles.statusPending;
//         const lower = status.toLowerCase();
//         if (lower === 'active' || lower === 'approved') return styles.statusActive;
//         if (lower === 'inactive' || lower === 'rejected' || lower === 'blocked') return styles.statusInactive;
//         if (lower === 'pending') return styles.statusPending;
//         if (lower === 'new') return styles.statusNew;
//         return styles.statusPending;
//     };

//     const formatDate = (dateString) => {
//         if (!dateString) return "-";
//         try {
//             const date = new Date(dateString);
//             return date.toLocaleDateString("en-GB", {
//                 day: '2-digit',
//                 month: 'short',
//                 year: 'numeric'
//             });
//         } catch {
//             return "-";
//         }
//     };

//     const searchOptions = [
//         { value: "vendorId", label: "Vendor ID" },
//         { value: "name", label: "Name" },
//         { value: "email", label: "Email" },
//         { value: "phoneNumber", label: "Mobile Number" },
//         { value: "city", label: "City" }
//     ];

//     return (
//         <div style={styles.container}>
//             {/* Header */}
//             {/* <div style={styles.header}>
//                 <div style={styles.title}>
//                     <Icons.Engineering /> Engineering Enquiries
//                     <span style={styles.titleBadge}>{filteredData.length}</span>
//                 </div>
//                 <div>
//                     <button
//                         onClick={() => window.location.reload()}
//                         style={{ ...styles.button, ...styles.buttonPrimary }}
//                     >
//                         <Icons.Refresh /> Refresh
//                     </button>
//                 </div>
//             </div> */}

//             {/* Filters */}
//             <div style={styles.filtersContainer}>
//                 <div style={styles.searchGroup}>
//                     <select
//                         value={searchType}
//                         onChange={(e) => setSearchType(e.target.value)}
//                         style={styles.select}
//                     >
//                         {searchOptions.map(option => (
//                             <option key={option.value} value={option.value}>
//                                 {option.label}
//                             </option>
//                         ))}
//                     </select>

//                     <input
//                         type="text"
//                         placeholder={getPlaceholderText()}
//                         value={searchQuery}
//                         onChange={(e) => setSearchQuery(e.target.value)}
//                         style={{
//                             ...styles.input,
//                             borderColor: searchQuery ? 'rgb(230 109 51)' : '#e2e8f0'
//                         }}
//                     />
//                 </div>

//                 <select
//                     value={statusFilter}
//                     onChange={(e) => setStatusFilter(e.target.value)}
//                     style={{ ...styles.select, minWidth: '110px' }}
//                 >
//                     <option value="">All Status</option>
//                     {uniqueStatuses.map(status => (
//                         <option key={status} value={status}>{status}</option>
//                     ))}
//                 </select>

//                 <select
//                     value={cityFilter}
//                     onChange={(e) => setCityFilter(e.target.value)}
//                     style={{ ...styles.select, minWidth: '110px' }}
//                 >
//                     <option value="">All Cities</option>
//                     {uniqueCities.map(city => (
//                         <option key={city} value={city}>{city}</option>
//                     ))}
//                 </select>

//                 <button
//                     onClick={clearAllFilters}
//                     style={{ ...styles.button, ...styles.buttonSecondary }}
//                 >
//                     <Icons.Clear /> Clear
//                 </button>

//                 {(searchQuery || statusFilter || cityFilter) && (
//                     <span style={{ fontSize: '12px', color: '#718096' }}>
//                         <strong>{filteredData.length}</strong> result{filteredData.length !== 1 && 's'}
//                     </span>
//                 )}
//             </div>

           
            

//             {/* Table */}
//             <div style={styles.tableWrapper}>
//                 <table style={styles.table}>
//                     <thead style={styles.thead}>
//                         <tr>
//                             <th style={{ ...styles.th, width: '50px', textAlign: 'center' }}>#</th>
//                             <th style={{ ...styles.th, textAlign: 'center' }}>Date</th>
//                             <th style={{ ...styles.th, textAlign: 'center' }}>
//                                 <div style={{ display: 'flex', alignItems: 'center', gap: '4px', justifyContent: 'center' }}>
//                                     <Icons.User /> Name
//                                 </div>
//                             </th>
//                             <th style={{ ...styles.th, textAlign: 'center' }}>
//                                 <div style={{ display: 'flex', alignItems: 'center', gap: '4px', justifyContent: 'center' }}>
//                                     <Icons.Email /> Email
//                                 </div>
//                             </th>
//                             <th style={{ ...styles.th, textAlign: 'center' }}>
//                                 <div style={{ display: 'flex', alignItems: 'center', gap: '4px', justifyContent: 'center' }}>
//                                     <Icons.Phone /> Phone
//                                 </div>
//                             </th>
//                             <th style={{ ...styles.th, textAlign: 'center' }}>City</th>
//                             <th style={{ ...styles.th, textAlign: 'center' }}>Status</th>
//                         </tr>
//                     </thead>
//                     <tbody>
//                         {filteredData.length > 0 ? (
//                             filteredData.map((user, index) => (
//                                 <tr
//                                     key={user.vendorId || index}
//                                     style={{
//                                         backgroundColor: index % 2 === 0 ? '#ffffff' : '#fafbfc',
//                                         transition: 'background 0.15s ease'
//                                     }}
//                                     onMouseEnter={(e) => e.currentTarget.style.backgroundColor = '#f0f4ff'}
//                                     onMouseLeave={(e) => e.currentTarget.style.backgroundColor = index % 2 === 0 ? '#ffffff' : '#fafbfc'}
//                                 >
//                                     <td style={{ ...styles.td, color: '#a0aec0' }}>{index + 1}</td>
//                                     <td style={styles.td}>{formatDate(user.registerTime)}</td>
//                                     <td style={{ ...styles.td, fontWeight: '500' }}>
//                                         {user.name || '-'}
//                                     </td>
//                                     <td style={styles.td}>
//                                         <a href={`mailto:${user.email}`} style={styles.emailLink}>
//                                             {user.email || '-'}
//                                         </a>
//                                     </td>
//                                     <td style={styles.td}>
//                                         <a href={`tel:${user.mobileNumber}`} style={styles.emailLink}>
//                                             {user.mobileNumber || '-'}
//                                         </a>
//                                     </td>
//                                     <td style={styles.td}>{user.city || '-'}</td>
//                                     <td style={styles.td}>
//                                         {user.status ? (
//                                             <span style={{
//                                                 ...styles.statusBadge,
//                                                 ...getStatusStyle(user.status)
//                                             }}>
//                                                 {user.status}
//                                             </span>
//                                         ) : (
//                                             <span style={{ color: '#a0aec0', fontSize: '11px' }}>—</span>
//                                         )}
//                                     </td>
//                                 </tr>
//                             ))
//                         ) : (
//                             <tr>
//                                 <td colSpan="7" style={{ padding: 0 }}>
//                                     <div style={styles.emptyState}>
//                                         <Icons.NoData />
//                                         <div style={styles.emptyStateText}>
//                                             {data.length === 0 ? 'Loading enquiries...' : 'No enquiries found'}
//                                         </div>
//                                         <div style={styles.emptyStateSubtext}>
//                                             {data.length === 0
//                                                 ? 'Please wait while we fetch the data'
//                                                 : (searchQuery || statusFilter || cityFilter)
//                                                     ? 'Try adjusting your filters to see more results'
//                                                     : 'No engineering enquiries are available'}
//                                         </div>
//                                     </div>
//                                 </td>
//                             </tr>
//                         )}
//                     </tbody>
//                 </table>
//             </div>
//         </div>
//     );
// };

// export default Engineeringenquery;





import React, { useEffect, useState, useMemo, useRef } from "react";
import { useLoader } from '../../../../context/LoaderProvider.jsx';
import {
    getEngineeringEnquiriesAPI,
} from "../../../Servicefile/clientManagementService.jsx";
import { Calendar, ChevronDown } from "lucide-react";

// ============================================
// PREMIUM ICONS COMPONENT
// ============================================
const Icons = {
    Search: () => (
        <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
            <circle cx="11" cy="11" r="8"/><path d="M21 21l-4.35-4.35"/>
        </svg>
    ),
    Refresh: () => (
        <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
            <path d="M23 4v6h-6M1 20v-6h6"/>
            <path d="M3.51 9a9 9 0 0 1 14.85-3.36L23 10M1 14l4.64 4.36A9 9 0 0 0 20.49 15"/>
        </svg>
    ),
    Clear: () => (
        <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
            <line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/>
        </svg>
    ),
    User: () => (
        <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
            <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"/>
            <circle cx="12" cy="7" r="4"/>
        </svg>
    ),
    Email: () => (
        <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
            <rect x="2" y="4" width="20" height="16" rx="2"/>
            <path d="M22 7l-8.97 5.7a1.94 1.94 0 0 1-2.06 0L2 7"/>
        </svg>
    ),
    Phone: () => (
        <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
            <path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72c.127.96.362 1.903.7 2.81a2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45c.907.339 1.85.574 2.81.7A2 2 0 0 1 22 16.92z"/>
        </svg>
    ),
    NoData: () => (
        <svg width="48" height="48" viewBox="0 0 24 24" fill="none" stroke="#6c757d" strokeWidth="1.5">
            <rect x="2" y="3" width="20" height="18" rx="2"/>
            <line x1="8" y1="21" x2="16" y2="21"/>
            <line x1="12" y1="17" x2="12" y2="21"/>
            <path d="M8 7h8M8 11h6M8 15h4"/>
        </svg>
    ),
    Engineering: () => (
        <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="rgb(230 109 51)" strokeWidth="2">
            <path d="M12 2L2 7l10 5 10-5-10-5z"/>
            <path d="M2 17l10 5 10-5"/>
            <path d="M2 12l10 5 10-5"/>
        </svg>
    ),
    Users: () => (
        <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
            <path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"/>
            <circle cx="9" cy="7" r="4"/>
            <path d="M23 21v-2a4 4 0 0 0-3-3.87"/>
            <path d="M16 3.13a4 4 0 0 1 0 7.75"/>
        </svg>
    ),
    CheckCircle: () => (
        <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
            <path d="M22 11.08V12a10 10 0 1 1-5.93-9.14"/>
            <polyline points="22 4 12 14.01 9 11.01"/>
        </svg>
    ),
    XCircle: () => (
        <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
            <circle cx="12" cy="12" r="10"/>
            <line x1="15" y1="9" x2="9" y2="15"/>
            <line x1="9" y1="9" x2="15" y2="15"/>
        </svg>
    ),
    Clock: () => (
        <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
            <circle cx="12" cy="12" r="10"/>
            <polyline points="12 6 12 12 16 14"/>
        </svg>
    ),
};

// Date filter options
const dateFilterOptions = ["All", "Today", "Yesterday", "This Week", "This Month", "Last Month", "This Year", "Custom Range"];

// ============================================
// PREMIUM STYLES
// ============================================
const styles = {
    container: {
        padding: '1px 5px',
        height: 'calc(100vh - 200px)',
        display: 'flex',
        flexDirection: 'column'
    },
    statsGrid: {
        display: 'grid',
        gridTemplateColumns: 'repeat(auto-fit, minmax(160px, 1fr))',
        gap: '12px',
        marginTop: '12px'
    },
    statCard: {
        background: 'white',
        borderRadius: '12px',
        padding: '12px 16px',
        border: '1px solid #edf2f7',
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        transition: 'all 0.2s ease'
    },
    statCardLeft: {
        display: 'flex',
        flexDirection: 'column'
    },
    statCardLabel: {
        fontSize: '11px',
        fontWeight: '500',
        color: '#94a3b8',
        textTransform: 'uppercase',
        letterSpacing: '0.3px'
    },
    statCardValue: {
        fontSize: '22px',
        fontWeight: '700',
        color: '#0f172a',
        marginTop: '2px',
        lineHeight: '1.2'
    },
    statCardIcon: {
        width: '36px',
        height: '36px',
        borderRadius: '10px',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        flexShrink: 0
    },
    header: {
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        padding: '0 0 12px 0',
        borderBottom: '2px solid #e9ecef',
        flexWrap: 'wrap',
        gap: '12px'
    },
    title: {
        fontSize: '20px',
        fontWeight: '600',
        color: '#2d3748',
        letterSpacing: '-0.3px',
        display: 'flex',
        alignItems: 'center',
        gap: '10px'
    },
    titleBadge: {
        background: 'rgb(230 109 51)',
        color: 'white',
        fontSize: '12px',
        fontWeight: '500',
        padding: '2px 12px',
        borderRadius: '12px',
        letterSpacing: '0.3px'
    },
    filtersContainer: {
        display: 'flex',
        flexWrap: 'wrap',
        alignItems: 'center',
        gap: '10px',
        padding: '10px 0 12px 0',
    
    },
    searchGroup: {
        display: 'flex',
        alignItems: 'center',
        gap: '8px',
        flex: '1 1 auto',
        minWidth: '280px'
    },
    select: {
        padding: '8px 12px',
        border: '1px solid #e2e8f0',
        borderRadius: '8px',
        background: 'white',
        fontSize: '13px',
        fontWeight: '500',
        color: '#2d3748',
        outline: 'none',
        transition: 'all 0.2s ease',
        height: '38px',
        minWidth: '130px',
        cursor: 'pointer'
    },
    input: {
        flex: '1',
        padding: '8px 14px',
        border: '1px solid #e2e8f0',
        borderRadius: '8px',
        fontSize: '13px',
        color: '#2d3748',
        outline: 'none',
        transition: 'all 0.2s ease',
        height: '38px',
        background: 'white'
    },
    button: {
        padding: '8px 16px',
        borderRadius: '8px',
        border: 'none',
        fontWeight: '500',
        fontSize: '13px',
        display: 'flex',
        alignItems: 'center',
        gap: '6px',
        cursor: 'pointer',
        transition: 'all 0.2s ease',
        height: '38px',
        whiteSpace: 'nowrap'
    },
    buttonPrimary: {
        background: 'rgb(230 109 51)',
        color: 'white'
    },
    buttonSecondary: {
        background: '#e2e8f0',
        color: '#4a5568'
    },
    dateFilterBtn: {
        display: 'flex',
        alignItems: 'center',
        gap: '8px',
        padding: '8px 16px',
        height: '38px',
        background: 'white',
        border: '1px solid #e2e8f0',
        borderRadius: '10px',
        fontSize: '13px',
        fontWeight: '500',
        cursor: 'pointer',
        transition: 'all 0.2s ease',
        color: '#334155'
    },
    dateFilterBtnActive: {
        borderColor: '#e66d33',
        color: '#e66d33'
    },
    tableWrapper: {
        flex: '1',
        overflow: 'auto',
        borderRadius: '10px',
        border: '1px solid #edf2f7',
        background: 'white',
        position: 'relative'
    },
    table: {
        width: '100%',
        fontSize: '13px',
        borderCollapse: 'collapse',
        minWidth: '600px'
    },
    thead: {
        position: 'sticky',
        top: 0,
        zIndex: 20
    },
    th: {
        padding: '12px 14px',
        textAlign: 'left',
        fontWeight: '600',
        fontSize: '12px',
        textTransform: 'uppercase',
        letterSpacing: '0.5px',
        color: 'white',
        background: 'rgb(230 109 51)',
        borderBottom: '2px solid #d45a1a',
        whiteSpace: 'nowrap'
    },
    td: {
        padding: '10px 14px',
        borderBottom: '1px solid #f1f5f9',
        color: '#2d3748',
        fontSize: '13px',
        textAlign: 'center'
    },
    statusBadge: {
        display: 'inline-flex',
        alignItems: 'center',
        gap: '4px',
        padding: '3px 12px',
        borderRadius: '20px',
        fontSize: '11px',
        fontWeight: '500',
        letterSpacing: '0.3px'
    },
    statusActive: {
        background: '#c6f6d5',
        color: '#276749'
    },
    statusInactive: {
        background: '#fed7d7',
        color: '#9b2c2c'
    },
    statusPending: {
        background: '#fefcbf',
        color: '#975a16'
    },
    statusNew: {
        background: '#bee3f8',
        color: '#2a4365'
    },
    emptyState: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        padding: '60px 20px',
        color: '#a0aec0'
    },
    emptyStateText: {
        marginTop: '16px',
        fontSize: '16px',
        fontWeight: '500',
        color: '#4a5568'
    },
    emptyStateSubtext: {
        fontSize: '13px',
        color: '#a0aec0',
        marginTop: '4px'
    },
    contactInfo: {
        display: 'flex',
        alignItems: 'center',
        gap: '4px',
        justifyContent: 'center'
    },
    emailLink: {
        color: '#4a5568',
        textDecoration: 'none',
        transition: 'color 0.2s ease'
    }
};

const Engineeringenquery = () => {
    const [data, setData] = useState([]);
    const [screenWidth, setScreenWidth] = useState(window.innerWidth);
    const { showLoader, hideLoader } = useLoader();

    // Filter states
    const [searchType, setSearchType] = useState("vendorId");
    const [searchQuery, setSearchQuery] = useState("");
    const [statusFilter, setStatusFilter] = useState("");
    const [cityFilter, setCityFilter] = useState("");
    const [filteredData, setFilteredData] = useState([]);

    // Date filter states - Default "All"
    const [selectedDateFilter, setSelectedDateFilter] = useState("All");
    const [showDateDropdown, setShowDateDropdown] = useState(false);
    const [customFromDate, setCustomFromDate] = useState(() => {
        const date = new Date();
        date.setDate(1);
        return date.toISOString().split('T')[0];
    });
    const [customToDate, setCustomToDate] = useState(() => {
        return new Date().toISOString().split('T')[0];
    });
    const [showCustomPicker, setShowCustomPicker] = useState(false);
    const dateDropdownRef = useRef(null);

    // Stats
    const [stats, setStats] = useState({
        total: 0,
        active: 0,
        inactive: 0,
        pending: 0,
        new: 0
    });

    useEffect(() => {
        const handleResize = () => setScreenWidth(window.innerWidth);
        window.addEventListener("resize", handleResize);
        return () => window.removeEventListener("resize", handleResize);
    }, []);

    // Close date dropdown
    useEffect(() => {
        const handleClickOutside = (event) => {
            if (dateDropdownRef.current && !dateDropdownRef.current.contains(event.target)) {
                setShowDateDropdown(false);
                setShowCustomPicker(false);
            }
        };
        document.addEventListener('mousedown', handleClickOutside);
        return () => document.removeEventListener('mousedown', handleClickOutside);
    }, []);

    useEffect(() => {
        const controller = new AbortController();

        const fetchUsers = async () => {
            showLoader();
            await new Promise((resolve) => setTimeout(resolve, 50));

            try {
                const data = await getEngineeringEnquiriesAPI(controller.signal);
                setData(data);
                setFilteredData(data);
                calculateStats(data);
            } catch (err) {
                if (err.name !== "AbortError") {
                    console.error("Error fetching users:", err);
                }
            } finally {
                hideLoader();
            }
        };

        fetchUsers();
        return () => controller.abort();
    }, []);

    // Calculate Stats
    const calculateStats = (dataArray) => {
        const total = dataArray.length;
        const active = dataArray.filter(item => 
            item.status?.toLowerCase() === 'active' || 
            item.status?.toLowerCase() === 'approved'
        ).length;
        const inactive = dataArray.filter(item => 
            item.status?.toLowerCase() === 'inactive' || 
            item.status?.toLowerCase() === 'rejected' || 
            item.status?.toLowerCase() === 'blocked'
        ).length;
        const pending = dataArray.filter(item => 
            item.status?.toLowerCase() === 'pending'
        ).length;
        const newCount = dataArray.filter(item => 
            item.status?.toLowerCase() === 'new'
        ).length;

        setStats({ total, active, inactive, pending, new: newCount });
    };

    // Get date range from selection - Returns null for "All"
    const getDateRangeFromSelection = () => {
        if (selectedDateFilter === "All") return null;

        const today = new Date();
        let from = new Date();
        let to = new Date();

        switch (selectedDateFilter) {
            case "Today":
                from = today;
                to = today;
                break;
            case "Yesterday":
                from.setDate(today.getDate() - 1);
                to.setDate(today.getDate() - 1);
                break;
            case "This Week": {
                const day = today.getDay();
                from.setDate(today.getDate() - day + (day === 0 ? -6 : 1));
                to = new Date(from);
                to.setDate(from.getDate() + 6);
                break;
            }
            case "This Month":
                from = new Date(today.getFullYear(), today.getMonth(), 1);
                to = new Date(today.getFullYear(), today.getMonth() + 1, 0);
                break;
            case "Last Month":
                from = new Date(today.getFullYear(), today.getMonth() - 1, 1);
                to = new Date(today.getFullYear(), today.getMonth(), 0);
                break;
            case "This Year":
                from = new Date(today.getFullYear(), 0, 1);
                to = new Date(today.getFullYear(), 11, 31);
                break;
            case "Custom Range":
                return { fromDate: customFromDate, toDate: customToDate };
            default:
                return null;
        }

        const formatDate = (date) => {
            const year = date.getFullYear();
            const month = String(date.getMonth() + 1).padStart(2, '0');
            const day = String(date.getDate()).padStart(2, '0');
            return `${year}-${month}-${day}`;
        };

        return {
            fromDate: formatDate(from),
            toDate: formatDate(to),
        };
    };

    // Filter by date range (frontend)
    const filterByDateRange = (items) => {
        const range = getDateRangeFromSelection();
        if (!range) return items;

        const startDate = new Date(range.fromDate);
        startDate.setHours(0, 0, 0, 0);
        const endDate = new Date(range.toDate);
        endDate.setHours(23, 59, 59, 999);

        return items.filter(item => {
            const registerDate = item.registerTime ? new Date(item.registerTime) : null;
            if (!registerDate) return false;
            return registerDate >= startDate && registerDate <= endDate;
        });
    };

    // Apply filters
    useEffect(() => {
        let result = data;

        // Apply date filter
        result = filterByDateRange(result);

        if (statusFilter) {
            result = result.filter(item => item.status === statusFilter);
        }

        if (cityFilter) {
            result = result.filter(item => item.city === cityFilter);
        }

        if (searchQuery.trim()) {
            const query = searchQuery.toLowerCase().trim();
            result = result.filter(item => {
                let fieldValue;

                if (searchType === "vendorId") {
                    fieldValue = item.vendorId || item.id;
                } else if (searchType === "phoneNumber") {
                    fieldValue = item.mobileNumber || item.phone;
                } else if (searchType === "email") {
                    fieldValue = item.email;
                } else if (searchType === "name") {
                    fieldValue = item.name;
                } else if (searchType === "city") {
                    fieldValue = item.city;
                } else {
                    fieldValue = item[searchType];
                }

                if (!fieldValue) return false;

                if (searchType === "phoneNumber") {
                    const cleanPartnerMobile = fieldValue.toString().replace(/\D/g, '');
                    const cleanQuery = query.replace(/\D/g, '');
                    return fieldValue.toString().toLowerCase().includes(query) ||
                        cleanPartnerMobile.includes(cleanQuery);
                }

                return fieldValue.toString().toLowerCase().includes(query);
            });
        }

        setFilteredData(result);
    }, [data, statusFilter, cityFilter, searchType, searchQuery, selectedDateFilter, customFromDate, customToDate]);

    const uniqueCities = useMemo(() => {
        const cities = data.map(item => item.city).filter(Boolean);
        return [...new Set(cities)].sort();
    }, [data]);

    const uniqueStatuses = useMemo(() => {
        const statuses = data.map(item => item.status).filter(Boolean);
        return [...new Set(statuses)].sort();
    }, [data]);

    const clearAllFilters = () => {
        setSearchQuery("");
        setStatusFilter("");
        setCityFilter("");
        setSearchType("vendorId");
        setSelectedDateFilter("All");
        setCustomFromDate(() => {
            const date = new Date();
            date.setDate(1);
            return date.toISOString().split('T')[0];
        });
        setCustomToDate(new Date().toISOString().split('T')[0]);
    };

    const getPlaceholderText = () => {
        switch (searchType) {
            case "vendorId": return "Search by Vendor ID...";
            case "name": return "Search by Name...";
            case "email": return "Search by Email...";
            case "phoneNumber": return "Search by Mobile...";
            case "city": return "Search by City...";
            default: return "Search...";
        }
    };

    const getStatusStyle = (status) => {
        if (!status) return styles.statusPending;
        const lower = status.toLowerCase();
        if (lower === 'active' || lower === 'approved') return styles.statusActive;
        if (lower === 'inactive' || lower === 'rejected' || lower === 'blocked') return styles.statusInactive;
        if (lower === 'pending') return styles.statusPending;
        if (lower === 'new') return styles.statusNew;
        return styles.statusPending;
    };

    const formatDate = (dateString) => {
        if (!dateString) return "-";
        try {
            const date = new Date(dateString);
            return date.toLocaleDateString("en-GB", {
                day: '2-digit',
                month: 'short',
                year: 'numeric'
            });
        } catch {
            return "-";
        }
    };

    const getDateFilterDisplayText = () => {
        if (selectedDateFilter === "All") return "All";
        if (selectedDateFilter === "Custom Range") {
            return `${customFromDate} to ${customToDate}`;
        }
        return selectedDateFilter;
    };

    const handleDateFilterSelect = (filter) => {
        setSelectedDateFilter(filter);
        if (filter === "Custom Range") {
            setShowCustomPicker(true);
        } else {
            setShowCustomPicker(false);
            setShowDateDropdown(false);
        }
    };

    const applyCustomRange = () => {
        setShowCustomPicker(false);
        setShowDateDropdown(false);
    };

    const searchOptions = [
        { value: "vendorId", label: "Vendor ID" },
        { value: "name", label: "Name" },
        { value: "email", label: "Email" },
        { value: "phoneNumber", label: "Mobile Number" },
        { value: "city", label: "City" }
    ];

    return (
        <div style={styles.container}>
            {/* Header */}
           

            {/* Dashboard Stats Cards */}
            <div style={styles.statsGrid}>
                <div style={styles.statCard}>
                    <div style={styles.statCardLeft}>
                        <span style={styles.statCardLabel}>Total Enquiries</span>
                        <span style={styles.statCardValue}>{stats.total}</span>
                    </div>
                    <div style={{ ...styles.statCardIcon, background: '#eef2ff' }}>
                        <Icons.Users />
                    </div>
                </div>
                <div style={styles.statCard}>
                    <div style={styles.statCardLeft}>
                        <span style={styles.statCardLabel}>Active</span>
                        <span style={{ ...styles.statCardValue, color: '#16a34a' }}>{stats.active}</span>
                    </div>
                    <div style={{ ...styles.statCardIcon, background: '#dcfce7' }}>
                        <Icons.CheckCircle />
                    </div>
                </div>
                <div style={styles.statCard}>
                    <div style={styles.statCardLeft}>
                        <span style={styles.statCardLabel}>Inactive</span>
                        <span style={{ ...styles.statCardValue, color: '#dc2626' }}>{stats.inactive}</span>
                    </div>
                    <div style={{ ...styles.statCardIcon, background: '#fee2e2' }}>
                        <Icons.XCircle />
                    </div>
                </div>
                <div style={styles.statCard}>
                    <div style={styles.statCardLeft}>
                        <span style={styles.statCardLabel}>Pending</span>
                        <span style={{ ...styles.statCardValue, color: '#f59e0b' }}>{stats.pending}</span>
                    </div>
                    <div style={{ ...styles.statCardIcon, background: '#fef3c7' }}>
                        <Icons.Clock />
                    </div>
                </div>
                <div style={styles.statCard}>
                    <div style={styles.statCardLeft}>
                        <span style={styles.statCardLabel}>New</span>
                        <span style={{ ...styles.statCardValue, color: '#2563eb' }}>{stats.new}</span>
                    </div>
                    <div style={{ ...styles.statCardIcon, background: '#dbeafe' }}>
                        <Icons.User />
                    </div>
                </div>
            </div>

            {/* Filters */}
            <div style={styles.filtersContainer}>
                <div style={styles.searchGroup}>
                    <select
                        value={searchType}
                        onChange={(e) => setSearchType(e.target.value)}
                        style={styles.select}
                    >
                        {searchOptions.map(option => (
                            <option key={option.value} value={option.value}>
                                {option.label}
                            </option>
                        ))}
                    </select>

                    <input
                        type="text"
                        placeholder={getPlaceholderText()}
                        value={searchQuery}
                        onChange={(e) => setSearchQuery(e.target.value)}
                        style={{
                            ...styles.input,
                            borderColor: searchQuery ? 'rgb(230 109 51)' : '#e2e8f0'
                        }}
                    />
                </div>

                {/* Date Filter */}
                <div ref={dateDropdownRef} style={{ position: "relative" }}>
                    <button
                        onClick={() => setShowDateDropdown(!showDateDropdown)}
                        style={{
                            ...styles.dateFilterBtn,
                            ...(showDateDropdown ? styles.dateFilterBtnActive : {})
                        }}
                    >
                        <Calendar size={14} color={showDateDropdown ? '#e66d33' : '#64748b'} />
                        <span>{getDateFilterDisplayText()}</span>
                        <ChevronDown size={14} color={showDateDropdown ? '#e66d33' : '#64748b'} />
                    </button>

                    {showDateDropdown && !showCustomPicker && (
                        <div style={{
                            position: "absolute",
                            top: "45px",
                            left: 0,
                            background: "white",
                            border: "1px solid #e2e8f0",
                            borderRadius: "12px",
                            boxShadow: "0 10px 25px rgba(0,0,0,0.1)",
                            zIndex: 1000,
                            minWidth: "180px",
                            overflow: "hidden"
                        }}>
                            {dateFilterOptions.map(option => (
                                <div
                                    key={option}
                                    onClick={() => handleDateFilterSelect(option)}
                                    style={{
                                        padding: "10px 16px",
                                        fontSize: "13px",
                                        cursor: "pointer",
                                        background: selectedDateFilter === option ? "#fef3e8" : "white",
                                        color: selectedDateFilter === option ? "#e66d33" : "#334155",
                                        borderBottom: "1px solid #f0f0f0"
                                    }}
                                >
                                    {option}
                                </div>
                            ))}
                        </div>
                    )}

                    {showCustomPicker && (
                        <div style={{
                            position: "absolute",
                            top: "45px",
                            left: 0,
                            background: "white",
                            border: "1px solid #e2e8f0",
                            borderRadius: "12px",
                            boxShadow: "0 10px 25px rgba(0,0,0,0.1)",
                            zIndex: 1000,
                            width: "280px",
                            padding: "16px"
                        }}>
                            <div style={{ marginBottom: "12px" }}>
                                <label style={{ fontSize: "12px", display: "block", marginBottom: "4px", color: "#64748b" }}>From Date</label>
                                <input
                                    type="date"
                                    value={customFromDate}
                                    onChange={(e) => setCustomFromDate(e.target.value)}
                                    style={{ width: "100%", padding: "8px", borderRadius: "8px", border: "1px solid #e2e8f0", fontSize: "13px" }}
                                    max={customToDate}
                                />
                            </div>
                            <div style={{ marginBottom: "16px" }}>
                                <label style={{ fontSize: "12px", display: "block", marginBottom: "4px", color: "#64748b" }}>To Date</label>
                                <input
                                    type="date"
                                    value={customToDate}
                                    onChange={(e) => setCustomToDate(e.target.value)}
                                    style={{ width: "100%", padding: "8px", borderRadius: "8px", border: "1px solid #e2e8f0", fontSize: "13px" }}
                                    min={customFromDate}
                                    max={new Date().toISOString().split('T')[0]}
                                />
                            </div>
                            <button
                                onClick={applyCustomRange}
                                style={{ width: "100%", padding: "10px", background: "#e66d33", color: "white", border: "none", borderRadius: "8px", fontSize: "13px", cursor: "pointer" }}
                            >
                                Apply Range
                            </button>
                        </div>
                    )}
                </div>

                <select
                    value={statusFilter}
                    onChange={(e) => setStatusFilter(e.target.value)}
                    style={{ ...styles.select, minWidth: '110px' }}
                >
                    <option value="">All Status</option>
                    {uniqueStatuses.map(status => (
                        <option key={status} value={status}>{status}</option>
                    ))}
                </select>

                <select
                    value={cityFilter}
                    onChange={(e) => setCityFilter(e.target.value)}
                    style={{ ...styles.select, minWidth: '110px' }}
                >
                    <option value="">All Cities</option>
                    {uniqueCities.map(city => (
                        <option key={city} value={city}>{city}</option>
                    ))}
                </select>

                <button
                    onClick={clearAllFilters}
                    style={{ ...styles.button, ...styles.buttonSecondary }}
                >
                    <Icons.Clear /> Clear
                </button>

                {(searchQuery || statusFilter || cityFilter || selectedDateFilter !== "All") && (
                    <span style={{ fontSize: '12px', color: '#718096' }}>
                        <strong>{filteredData.length}</strong> result{filteredData.length !== 1 && 's'}
                    </span>
                )}
            </div>

            {/* Table */}
            <div style={styles.tableWrapper}>
                <table style={styles.table}>
                    <thead style={styles.thead}>
                        <tr>
                            <th style={{ ...styles.th, width: '50px', textAlign: 'center' }}>#</th>
                            <th style={{ ...styles.th, textAlign: 'center' }}>Date</th>
                            <th style={{ ...styles.th, textAlign: 'center' }}>
                                <div style={{ display: 'flex', alignItems: 'center', gap: '4px', justifyContent: 'center' }}>
                                    <Icons.User /> Name
                                </div>
                            </th>
                            <th style={{ ...styles.th, textAlign: 'center' }}>
                                <div style={{ display: 'flex', alignItems: 'center', gap: '4px', justifyContent: 'center' }}>
                                    <Icons.Email /> Email
                                </div>
                            </th>
                            <th style={{ ...styles.th, textAlign: 'center' }}>
                                <div style={{ display: 'flex', alignItems: 'center', gap: '4px', justifyContent: 'center' }}>
                                    <Icons.Phone /> Phone
                                </div>
                            </th>
                            <th style={{ ...styles.th, textAlign: 'center' }}>City</th>
                            <th style={{ ...styles.th, textAlign: 'center' }}>Status</th>
                        </tr>
                    </thead>
                    <tbody>
                        {filteredData.length > 0 ? (
                            filteredData.map((user, index) => (
                                <tr
                                    key={user.vendorId || index}
                                    style={{
                                        backgroundColor: index % 2 === 0 ? '#ffffff' : '#fafbfc',
                                        transition: 'background 0.15s ease'
                                    }}
                                    onMouseEnter={(e) => e.currentTarget.style.backgroundColor = '#f0f4ff'}
                                    onMouseLeave={(e) => e.currentTarget.style.backgroundColor = index % 2 === 0 ? '#ffffff' : '#fafbfc'}
                                >
                                    <td style={{ ...styles.td, color: '#a0aec0' }}>{index + 1}</td>
                                    <td style={styles.td}>{formatDate(user.registerTime)}</td>
                                    <td style={{ ...styles.td, fontWeight: '500' }}>
                                        {user.name || '-'}
                                    </td>
                                    <td style={styles.td}>
                                        <a href={`mailto:${user.email}`} style={styles.emailLink}>
                                            {user.email || '-'}
                                        </a>
                                    </td>
                                    <td style={styles.td}>
                                        <a href={`tel:${user.mobileNumber}`} style={styles.emailLink}>
                                            {user.mobileNumber || '-'}
                                        </a>
                                    </td>
                                    <td style={styles.td}>{user.city || '-'}</td>
                                    <td style={styles.td}>
                                        {user.status ? (
                                            <span style={{
                                                ...styles.statusBadge,
                                                ...getStatusStyle(user.status)
                                            }}>
                                                {user.status}
                                            </span>
                                        ) : (
                                            <span style={{ color: '#a0aec0', fontSize: '11px' }}>—</span>
                                        )}
                                    </td>
                                </tr>
                            ))
                        ) : (
                            <tr>
                                <td colSpan="7" style={{ padding: 0 }}>
                                    <div style={styles.emptyState}>
                                        <Icons.NoData />
                                        <div style={styles.emptyStateText}>
                                            {data.length === 0 ? 'Loading enquiries...' : 'No enquiries found'}
                                        </div>
                                        <div style={styles.emptyStateSubtext}>
                                            {data.length === 0
                                                ? 'Please wait while we fetch the data'
                                                : (searchQuery || statusFilter || cityFilter || selectedDateFilter !== "All")
                                                    ? 'Try adjusting your filters to see more results'
                                                    : 'No engineering enquiries are available'}
                                        </div>
                                    </div>
                                </td>
                            </tr>
                        )}
                    </tbody>
                </table>
            </div>
        </div>
    );
};

export default Engineeringenquery;